import { UiBox, UiIconStandard, UiTypography } from "@smp/ui";
import { useMemo } from "react";

import { useStyles } from "./notification.css";
import { IProps } from "./notification.types";

export const Notification = ({
  actions,
  body,
  title,
  level = "info",
}: IProps) => {
  const classes = useStyles();

  const iconVariant = useMemo(
    () => (level === "danger" ? "error" : level),
    [level],
  );

  return useMemo(
    () => (
      <UiBox
        display="flex"
        flexDirection="row"
        className={classes.notification}
        paddingBottom={2}
        paddingLeft={2}
        paddingRight={2}
        paddingTop={4}
      >
        <UiBox flexGrow={0} width={50}>
          <UiIconStandard variant={iconVariant} />
        </UiBox>
        <UiBox flexGrow={1} paddingLeft={2}>
          <UiBox>
            <UiTypography gutterBottom variant="h6">
              {title}
            </UiTypography>
            {body}
          </UiBox>
          <UiBox display="flex" justifyContent="flex-end" paddingTop={2}>
            {actions}
          </UiBox>
        </UiBox>
      </UiBox>
    ),
    [actions, body, classes.notification, iconVariant, title],
  );
};
